
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anyGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"schoolPendingCount"},"name":{"kind":"Name","value":"autorosterSchoolCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notNull"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"pendingObject","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"notNull"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"pendingStatus","block":false}}]}}]}}]}}],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"targetType"},"value":{"kind":"StringValue","value":"Cccisd\\Nexus\\Models\\Group","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"autorosterSchoolStart","block":false},{"kind":"StringValue","value":"autorosterClassStart","block":false},{"kind":"StringValue","value":"autorosterSchoolPreflightSuccess","block":false},{"kind":"StringValue","value":"autorosterSchoolPreflightFailure","block":false},{"kind":"StringValue","value":"autorosterSchoolSyncSuccess","block":false},{"kind":"StringValue","value":"autorosterSchoolSyncFailure","block":false},{"kind":"StringValue","value":"autorosterClassPreflightSuccess","block":false},{"kind":"StringValue","value":"autorosterClassPreflightFailure","block":false},{"kind":"StringValue","value":"autorosterClassSyncSuccess","block":false},{"kind":"StringValue","value":"autorosterClassSyncFailure","block":false},{"kind":"StringValue","value":"nightlySchoolPreflightSuccess","block":false},{"kind":"StringValue","value":"nightlySchoolPreflightFailure","block":false},{"kind":"StringValue","value":"nightlySchoolSyncSuccess","block":false},{"kind":"StringValue","value":"nightlySchoolSyncFailure","block":false},{"kind":"StringValue","value":"nightlyClassPreflightSuccess","block":false},{"kind":"StringValue","value":"nightlyClassPreflightFailure","block":false},{"kind":"StringValue","value":"nightlyClassSyncSuccess","block":false},{"kind":"StringValue","value":"nightlyClassSyncFailure","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"eventId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1404}};
    doc.loc.source = {"body":"query($groupId: Int) {\n    groups(as: ANY) {\n        anyGroup(groupId: [$groupId], context: GLOBAL) {\n            schoolPendingCount: autorosterSchoolCount(filter: { AND: { notNull: { field: \"pendingObject\" }, notNull: { field: \"pendingStatus\"} } })\n        }\n    }\n    events(as: ANY) {\n        event (\n            targetId: [$groupId]\n            targetType: \"Cccisd\\\\Nexus\\\\Models\\\\Group\"\n            eventType: [\n                \"autorosterSchoolStart\"\n                \"autorosterClassStart\"\n                \"autorosterSchoolPreflightSuccess\"\n                \"autorosterSchoolPreflightFailure\"\n                \"autorosterSchoolSyncSuccess\"\n                \"autorosterSchoolSyncFailure\"\n                \"autorosterClassPreflightSuccess\"\n                \"autorosterClassPreflightFailure\"\n                \"autorosterClassSyncSuccess\"\n                \"autorosterClassSyncFailure\"\n                \"nightlySchoolPreflightSuccess\"\n                \"nightlySchoolPreflightFailure\"\n                \"nightlySchoolSyncSuccess\"\n                \"nightlySchoolSyncFailure\"\n                \"nightlyClassPreflightSuccess\"\n                \"nightlyClassPreflightFailure\"\n                \"nightlyClassSyncSuccess\"\n                \"nightlyClassSyncFailure\"\n            ]\n            orderBy: { field: \"eventId\", direction: DESC}\n        ) {\n            eventAt\n            eventType\n            metadata\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
